import React, { useState, useEffect } from 'react';
import { NavLink, Link, useLocation } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    faBars,
    faTimes,
} from '@fortawesome/free-solid-svg-icons';

function Header() {
    const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

    const location = useLocation();

    useEffect(() => {
        setIsMobileMenuOpen(false);
    }, [location]);

    const toggleMobileMenu = () => {
        setIsMobileMenuOpen((prev) => !prev);
    };

    useEffect(() => {
        document.body.style.overflow = isMobileMenuOpen ? 'hidden' : 'unset';
        return () => {
            document.body.style.overflow = 'unset';
        };
    }, [isMobileMenuOpen]);

    const navLinks = [
        { path: '/', label: 'Home' },
        { path: '/about', label: 'About' },
        { path: '/services', label: 'Services' },
        { path: '/projects', label: 'Projects' },
        { path: '/blogs', label: 'Blogs' },
        { path: '/faqs', label: 'FAQ' },
        { path: '/contact', label: 'Contact' },
    ];

    return (
        <>
            <header className="bg-bg-dark/80 backdrop-blur-md shadow-lg fixed w-full z-50 border-b border-border-subtle flex items-stretch min-h-[70px]">
                <div className="max-w-6xl mx-auto px-5 flex justify-between items-stretch flex-grow">
                    <Link
                        to="/"
                        className="text-2xl font-bold text-text-white no-underline flex items-center"
                    >
                        Rishabh&nbsp;<span className="text-accent-red">Gupta</span>
                    </Link>

                    <nav className="hidden md:block flex items-stretch">
                        <ul className="flex space-x-8 flex-grow items-stretch">
                            {navLinks.map((link) => (
                                <li
                                    key={link.path}
                                    className="flex items-stretch"
                                >
                                    <NavLink
                                        to={link.path}
                                        end={link.path === '/'}
                                        className="flex items-end relative px-2 py-5 h-full"
                                    >
                                        {({ isActive }) => (
                                            <>
                                                <span
                                                    className={`text-text-gray font-medium text-lg transition-colors duration-300 ${
                                                        isActive ? 'text-accent-red' : ''
                                                    }`}
                                                >
                                                    {link.label}
                                                </span>

                                                {isActive && (
                                                    <span className="absolute bottom-0 left-0 w-full h-0.5 bg-accent-red rounded-sm"></span>
                                                )}
                                            </>
                                        )}
                                    </NavLink>
                                </li>
                            ))}
                        </ul>
                    </nav>

                    <div className="md:hidden flex items-center">
                        <button
                            onClick={toggleMobileMenu}
                            className="text-text-white text-2xl focus:outline-none"
                        >
                            <FontAwesomeIcon
                                icon={isMobileMenuOpen ? faTimes : faBars}
                            />
                        </button>
                    </div>

                    <Link
                        to="/contact"
                        className="hidden md:block bg-accent-red text-text-white rounded-full px-3 py-1 ml-8 text-base transition-all duration-300 hover:bg-red-700 hover:-translate-y-0.5 no-underline self-center"
                    >
                        Hire me
                    </Link>
                </div>
            </header>

            {isMobileMenuOpen && (
                <div className="md:hidden fixed top-[70px] left-0 right-0 bg-bg-dark backdrop-blur-md z-40 h-[calc(100vh-70px)] overflow-y-auto">
                    <nav className="flex flex-col items-center w-full">
                        <ul className="flex flex-col space-y-1 w-full px-0">
                            {navLinks.map((link) => (
                                <li key={link.path} className="w-full">
                                    <NavLink
                                        to={link.path}
                                        end={link.path === '/'}
                                        className="block text-text-gray font-medium text-lg py-3 px-6 rounded-none hover:bg-white/5 transition-colors duration-300"
                                    >
                                        {({ isActive }) => (
                                            <span
                                                className={
                                                    isActive ? 'text-accent-red' : ''
                                                }
                                            >
                                                {link.label}
                                            </span>
                                        )}
                                    </NavLink>
                                </li>
                            ))}
                        </ul>

                        <Link
                            to="/contact"
                            className="mt-6 mb-6 bg-accent-red text-text-white rounded-full px-5 py-2 text-lg transition-all duration-300 hover:bg-red-700 no-underline"
                        >
                            Hire me
                        </Link>
                    </nav>
                </div>
            )}
        </>
    );
}

export default Header;